export const allCountries = {
  ad: {
    countryCode: 'ad',
    name: 'Andorra'
  },
  ae: {
    countryCode: 'ae',
    name: 'United Arab Emirates',
    regions: {
      ae0: { factualCode: 'دبي', name: 'دبي' },
      ae1: { factualCode: 'أبو ظبي', name: 'أبو ظبي' },
      ae2: { factualCode: 'الشارقة', name: 'الشارقة' },
      ae3: { factualCode: 'إمارة رأس الخيمة', name: 'إمارة رأس الخيمة' },
      ae4: { factualCode: 'عجمان', name: 'عجمان' },
      ae5: { factualCode: 'الفجيرة', name: 'الفجيرة' },
      ae6: { factualCode: 'إمارة أمّ القيوين', name: 'إمارة أمّ القيوين' }
    }
  },
  af: {
    countryCode: 'af',
    name: 'Afghanistan'
  },
  ag: {
    countryCode: 'ag',
    name: 'Antigua and Barbuda'
  },
  ai: {
    countryCode: 'ai',
    name: 'Anguilla'
  },
  al: {
    countryCode: 'al',
    name: 'Albania'
  },
  am: {
    countryCode: 'am',
    name: 'Armenia'
  },
  an: {
    countryCode: 'an',
    name: 'Netherlands Antilles'
  },
  ao: {
    countryCode: 'ao',
    name: 'Angola'
  },
  aq: {
    countryCode: 'aq',
    name: 'Antarctica'
  },
  ar: {
    carriers: [
      {
        code: ['722-01'],
        name: 'Tuenti Argentina'
      },
      {
        code: ['722-010'],
        name: 'Movicom'
      },
      {
        code: ['722-020'],
        name: 'Nextel Argentina srl'
      },
      {
        code: ['722-07'],
        name: 'Movistar'
      },
      {
        code: ['722-310', '722-320', '722-330'],
        name: 'Claro'
      },
      {
        code: ['722-341'],
        name: 'Telecom Personal'
      },
      {
        code: ['722-350'],
        name: 'Hutchinson (PORT HABLE)'
      }
    ],
    countryCode: 'ar',
    name: 'Argentina'
  },
  as: {
    countryCode: 'as',
    name: 'American Samoa'
  },
  at: {
    carriers: [
      {
        code: ['232-01'],
        name: 'A1.net'
      },
      {
        code: ['232-03', '232-04'],
        name: 'T-Mobile AT'
      },
      {
        code: ['232-05', '232-06'],
        name: 'Orange AT'
      },
      {
        code: ['232-07'],
        name: 'tele.ring'
      },
      {
        code: ['232-08'],
        name: 'Lycamobile'
      },
      {
        code: ['232-09'],
        name: 'Tele2Mobil'
      },
      {
        code: ['232-10'],
        name: '3AT'
      },
      {
        code: ['232-11'],
        name: 'bob'
      },
      {
        code: ['232-12'],
        name: 'yesss!'
      },
      {
        code: ['232-13'],
        name: 'UPC Mobile'
      },
      {
        code: ['232-15'],
        name: 'Vectone Mobile'
      },
      {
        code: ['232-91'],
        name: 'GSM-R A'
      }
    ],
    countryCode: 'at',
    name: 'Austria'
  },
  au: {
    countryCode: 'au',
    name: 'Australia'
  },
  aw: {
    countryCode: 'aw',
    name: 'Aruba'
  },
  ax: {
    countryCode: 'ax',
    name: 'Åland Islands'
  },
  az: {
    countryCode: 'az',
    name: 'Azerbaijan'
  },
  ba: {
    countryCode: 'ba',
    name: 'Bosnia and Herzegovina'
  },
  bb: {
    countryCode: 'bb',
    name: 'Barbados'
  },
  bd: {
    countryCode: 'bd',
    name: 'Bangladesh'
  },
  be: {
    countryCode: 'be',
    name: 'Belgium'
  },
  bf: {
    countryCode: 'bf',
    name: 'Burkina Faso'
  },
  bg: {
    countryCode: 'bg',
    name: 'Bulgaria'
  },
  bh: {
    countryCode: 'bh',
    name: 'Bahrain'
  },
  bi: {
    countryCode: 'bi',
    name: 'Burundi'
  },
  bj: {
    countryCode: 'bj',
    name: 'Benin'
  },
  bl: {
    countryCode: 'bl',
    name: 'Saint Barthélemy'
  },
  bm: {
    countryCode: 'bm',
    name: 'Bermuda'
  },
  bn: {
    countryCode: 'bn',
    name: 'Brunei'
  },
  bo: {
    countryCode: 'bo',
    name: 'Bolivia'
  },
  bq: {
    countryCode: 'bq',
    name: 'British Antarctic Territory'
  },
  br: {
    carriers: [
      {
        code: ['724-00', '724-39'],
        name: 'Nextel'
      },
      {
        code: ['724-02', '724-03', '724-04'],
        name: 'TIM'
      },
      {
        code: ['724-05', '724-38'],
        name: 'Claro'
      },
      {
        code: ['724-06', '724-10', '724-11', '724-23'],
        name: 'Vivo'
      },
      {
        code: ['724-15'],
        name: 'Sercomtel'
      },
      {
        code: ['724-16'],
        name: 'Brasil Telecom GSM'
      },
      {
        code: ['724-18'],
        name: 'datora'
      },
      {
        code: ['724-30', '724-31'],
        name: 'Oi'
      },
      {
        code: ['724-32', '724-33', '724-34'],
        name: 'CTBC Celular'
      },
      {
        code: ['724-37'],
        name: 'aeiou'
      },
      {
        code: ['724-54'],
        name: 'Conecta'
      }
    ],
    countryCode: 'br',
    name: 'Brazil'
  },
  bs: {
    countryCode: 'bs',
    name: 'Bahamas'
  },
  bt: {
    countryCode: 'bt',
    name: 'Bhutan'
  },
  bv: {
    countryCode: 'bv',
    name: 'Bouvet Island'
  },
  bw: {
    countryCode: 'bw',
    name: 'Botswana'
  },
  by: {
    countryCode: 'by',
    name: 'Belarus'
  },
  bz: {
    countryCode: 'bz',
    name: 'Belize'
  },
  ca: {
    countryCode: 'ca',
    name: 'Canada'
  },
  cc: {
    countryCode: 'cc',
    name: 'Cocos [Keeling] Islands'
  },
  cd: {
    countryCode: 'cd',
    name: 'Congo - Kinshasa'
  },
  cf: {
    countryCode: 'cf',
    name: 'Central African Republic'
  },
  cg: {
    countryCode: 'cg',
    name: 'Congo - Brazzaville'
  },
  ch: {
    carriers: [
      {
        code: ['228-01'],
        name: 'Swisscom'
      },
      {
        code: ['228-02'],
        name: 'Sunrise'
      },
      {
        code: ['228-03'],
        name: 'Salt'
      },
      {
        code: ['228-06'],
        name: 'SBB-CFF-FFS'
      },
      {
        code: ['228-07'],
        name: 'IN&Phone'
      },
      {
        code: ['228-08'],
        name: 'Tele4u'
      },
      {
        code: ['228-52'],
        name: 'Barablu'
      }
    ],
    countryCode: 'ch',
    name: 'Switzerland'
  },
  ci: {
    countryCode: 'ci',
    name: 'Côte d’Ivoire'
  },
  ck: {
    countryCode: 'ck',
    name: 'Cook Islands'
  },
  cl: {
    carriers: [
      {
        code: ['730-01', '730-10'],
        name: 'Entel'
      },
      {
        code: ['730-02', '730-07'],
        name: 'Movistar'
      },
      {
        code: ['730-03'],
        name: 'Claro'
      },
      {
        code: ['730-04', '730-09'],
        name: 'WOM'
      },
      {
        code: ['730-06'],
        name: 'Telefónica del Sur'
      },
      {
        code: ['730-08'],
        name: 'VTR Móvil'
      },
      {
        code: ['730-12'],
        name: 'Colo-Colo Móvil Wanderers Móvil'
      },
      {
        code: ['730-13'],
        name: 'Virgin Mobile'
      },
      {
        code: ['730-99'],
        name: 'Will'
      }
    ],
    countryCode: 'cl',
    name: 'Chile',
    regions: {
      ai: {
        factualCode: 'AISÉN',
        name: 'Aisén'
      },
      an: {
        factualCode: 'ANTOFAGASTA',
        name: 'Antofagasta'
      },
      ar: {
        factualCode: 'ARICA',
        name: 'Arica'
      },
      au: {
        factualCode: 'ARAUCO',
        name: 'Arauco'
      },
      bi: {
        factualCode: 'BIOBÍO',
        name: 'Biobío'
      },
      ca: {
        factualCode: 'CACHAPOAL',
        name: 'Cachapoal'
      },
      cb: {
        factualCode: 'CHACABUCO',
        name: 'Chacabuco'
      },
      cc: {
        factualCode: 'CARDENAL CARO',
        name: 'Cardenal Caro'
      },
      cd: {
        factualCode: 'CORDILLERA',
        name: 'Cordillera'
      },
      ce: {
        factualCode: 'CHILOÉ',
        name: 'Chiloé'
      },
      ch: {
        factualCode: 'CHOAPA',
        name: 'Choapa'
      },
      ci: {
        factualCode: 'COIHAIQUE',
        name: 'Coihaique'
      },
      cl: {
        factualCode: 'COLCHAGUA',
        name: 'Colchagua'
      },
      cn: {
        factualCode: 'CONCEPCIÓN',
        name: 'Concepción'
      },
      co: {
        factualCode: 'COPIAPÓ',
        name: 'Copiapó'
      },
      cq: {
        factualCode: 'CAUQUENES',
        name: 'Cauquenes'
      },
      cr: {
        factualCode: 'CHAÑARAL',
        name: 'Chañaral'
      },
      ct: {
        factualCode: 'CAUTÍN',
        name: 'Cautín'
      },
      cu: {
        factualCode: 'CURICÓ',
        name: 'Curicó'
      },
      el: {
        factualCode: 'EL LOA',
        name: 'El Loa'
      },
      eq: {
        factualCode: 'ELQUI',
        name: 'Elqui'
      },
      gc: {
        factualCode: 'GENERAL CARRERA',
        name: 'General Carrera'
      },
      hu: {
        factualCode: 'HUASCO',
        name: 'Huasco'
      },
      ie: {
        factualCode: 'IQUIQUE',
        name: 'Iquique'
      },
      ip: {
        factualCode: 'ISLA DE PASCUA',
        name: 'Isla de Pascua'
      },
      la: {
        factualCode: 'LOS ANDES',
        name: 'Los Andes'
      },
      ll: {
        factualCode: 'LLANQUIHUE',
        name: 'Llanquihue'
      },
      lm: {
        factualCode: 'LIMARÍ',
        name: 'Limarí'
      },
      ln: {
        factualCode: 'LINARES',
        name: 'Linares'
      },
      me: {
        factualCode: 'MELIPILLA',
        name: 'Melipilla'
      },
      mg: {
        factualCode: 'MAGALLANES',
        name: 'Magallanes'
      },
      mi: {
        factualCode: 'MAIPO',
        name: 'Maipo'
      },
      ml: {
        factualCode: 'MALLECO',
        name: 'Malleco'
      },
      mm: {
        factualCode: 'MARGA MARGA',
        name: 'Marga Marga'
      },
      nu: {
        factualCode: 'ÑUBLE',
        name: 'Ñuble'
      },
      os: {
        factualCode: 'OSORNO',
        name: 'Osorno'
      },
      pe: {
        factualCode: 'PETORCA',
        name: 'Petorca'
      },
      pl: {
        factualCode: 'PALENA',
        name: 'Palena'
      },
      qt: {
        factualCode: 'QUILLOTA',
        name: 'Quillota'
      },
      ra: {
        factualCode: 'RANCO',
        name: 'Ranco'
      },
      sa: {
        factualCode: 'SAN ANTONIO',
        name: 'San Antonio'
      },
      sf: {
        factualCode: 'SAN FELIPE',
        name: 'San Felipe'
      },
      sg: {
        factualCode: 'SANTIAGO',
        name: 'Santiago'
      },
      tc: {
        factualCode: 'TALCA',
        name: 'Talca'
      },
      tg: {
        factualCode: 'TALAGANTE',
        name: 'Talagante'
      },
      tm: {
        factualCode: 'TAMARUGAL',
        name: 'Tamarugal'
      },
      to: {
        factualCode: 'TOCOPILLA',
        name: 'Tocopilla'
      },
      ue: {
        factualCode: 'ÚLTIMA ESPERANZA',
        name: 'Última Esperanza'
      },
      vd: {
        factualCode: 'VALDIVIA',
        name: 'Valdivia'
      },
      vs: {
        factualCode: 'VALPARAÍSO',
        name: 'Valparaíso'
      }
    }
  },
  cm: {
    countryCode: 'cm',
    name: 'Cameroon'
  },
  cn: {
    countryCode: 'cn',
    name: 'China',
    regions: {
      cn1: { factualCode: '安徽省', name: 'Anhui' },
      cn10: { factualCode: '河北省', name: 'Hebei' },
      cn11: { factualCode: '黑龙江省', name: 'Heilongjiang' },
      cn12: { factualCode: '河南省', name: 'Henan' },
      cn13: { factualCode: '湖北省', name: 'Hubei' },
      cn14: { factualCode: '湖南省', name: 'Hunan' },
      cn15: { factualCode: '内蒙古自治区', name: 'Inner Mongolia' },
      cn16: { factualCode: '江苏省', name: 'Jiangsu' },
      cn17: { factualCode: '江西省', name: 'Jiangxi' },
      cn18: { factualCode: '吉林省', name: 'Jilin' },
      cn19: { factualCode: '辽宁省', name: 'Liaoning' },
      cn2: { factualCode: '北京市', name: 'Beijing' },
      cn20: { factualCode: '宁夏回族自治区', name: 'Ningxia Hui' },
      cn21: { factualCode: '青海省', name: 'Qinghai' },
      cn22: { factualCode: '陕西省', name: 'Shaanxi' },
      cn23: { factualCode: '山东省', name: 'Shandong' },
      cn24: { factualCode: '上海市', name: 'Shanghai' },
      cn25: { factualCode: '山西省', name: 'Shanxi' },
      cn26: { factualCode: '四川省', name: 'Sichuan' },
      cn27: { factualCode: '天津市', name: 'Tianjin' },
      cn28: { factualCode: '西藏自治区', name: 'Tibet' },
      cn29: { factualCode: '新疆维吾尔自治区', name: 'Xinjiang Uyghur' },
      cn3: { factualCode: '重庆市', name: 'Chongqing' },
      cn30: { factualCode: '云南省', name: 'Yunnan' },
      cn31: { factualCode: '浙江省', name: 'Zhejiang' },
      cn4: { factualCode: '福建省', name: 'Fujian' },
      cn5: { factualCode: '甘肃省', name: 'Gansu' },
      cn6: { factualCode: '广东省', name: 'Guangdong' },
      cn7: { factualCode: '贵州省', name: 'Guizhou' },
      cn8: { factualCode: '广西壮族自治区', name: 'Guangxi Zhuang' },
      cn9: { factualCode: '海南省', name: 'Hainan' }
    }
  },
  co: {
    carriers: [
      {
        code: ['732-001', '732-102', '732-123'],
        name: 'movistar'
      },
      {
        code: ['732-002'],
        name: 'Edatel'
      },
      {
        code: ['732-099'],
        name: 'EMCALI'
      },
      {
        code: ['732-101'],
        name: 'Claro'
      },
      {
        code: ['732-103', '732-111'],
        name: 'Tigo'
      },
      {
        code: ['732-130'],
        name: 'AVANTEL'
      }
    ],
    countryCode: 'co',
    name: 'Colombia',
    regions: {
      ama: {
        factualCode: 'AMAZONAS',
        name: 'Amazonas'
      },
      ant: {
        factualCode: 'ANTIOQUIA',
        name: 'Antioquia'
      },
      ara: {
        factualCode: 'ARAUCA',
        name: 'Arauca'
      },
      atl: {
        factualCode: 'ATLÁNTICO',
        name: 'Atlántico'
      },
      bol: {
        factualCode: 'BOLÍVAR',
        name: 'Bolívar'
      },
      boy: {
        factualCode: 'BOYACÁ',
        name: 'Boyacá'
      },
      cal: {
        factualCode: 'CALDAS',
        name: 'Caldas'
      },
      caq: {
        factualCode: 'CAQUETÁ',
        name: 'Caquetá'
      },
      cas: {
        factualCode: 'CASANARE',
        name: 'Casanare'
      },
      cau: {
        factualCode: 'CAUCA',
        name: 'Cauca'
      },
      ces: {
        factualCode: 'CESAR',
        name: 'Cesar'
      },
      cho: {
        factualCode: 'CHOCÓ',
        name: 'Chocó'
      },
      cor: {
        factualCode: 'CÓRDOBA',
        name: 'Córdoba'
      },
      cun: {
        factualCode: 'CUNDINAMARCA',
        name: 'Cundinamarca'
      },
      dc: {
        factualCode: 'BOGOTÁ, D.C.',
        name: 'Bogotá D.C.'
      },
      gua: {
        factualCode: 'GUAINÍA',
        name: 'Guainía'
      },
      guv: {
        factualCode: 'GUAVIARE',
        name: 'Guaviare'
      },
      hui: {
        factualCode: 'HUILA',
        name: 'Huila'
      },
      lag: {
        factualCode: 'LA GUAJIRA',
        name: 'La Guajira'
      },
      mag: {
        factualCode: 'MAGDALENA',
        name: 'Magdalena'
      },
      met: {
        factualCode: 'META',
        name: 'Meta'
      },
      nar: {
        factualCode: 'NARIÑO',
        name: 'Nariño'
      },
      nsa: {
        factualCode: 'NORTE DE SANTANDER',
        name: 'Norte de Santander'
      },
      put: {
        factualCode: 'PUTUMAYO',
        name: 'Putumayo'
      },
      qui: {
        factualCode: 'QUINDÍO',
        name: 'Quindío'
      },
      ris: {
        factualCode: 'RISARALDA',
        name: 'Risaralda'
      },
      san: {
        factualCode: 'SANTANDER',
        name: 'Santander'
      },
      suc: {
        factualCode: 'SUCRE',
        name: 'Sucre'
      },
      tol: {
        factualCode: 'TOLIMA',
        name: 'Tolima'
      },
      vac: {
        factualCode: 'VALLE DEL CAUCA',
        name: 'Valle del Cauca'
      },
      vid: {
        factualCode: 'VICHADA',
        name: 'Vichada'
      }
    }
  },
  cr: {
    countryCode: 'cr',
    name: 'Costa Rica'
  },
  cs: {
    countryCode: 'cs',
    name: 'Serbia and Montenegro'
  },
  ct: {
    countryCode: 'ct',
    name: 'Canton and Enderbury Islands'
  },
  cu: {
    countryCode: 'cu',
    name: 'Cuba'
  },
  cv: {
    countryCode: 'cv',
    name: 'Cape Verde'
  },
  cx: {
    countryCode: 'cx',
    name: 'Christmas Island'
  },
  cy: {
    countryCode: 'cy',
    name: 'Cyprus'
  },
  cz: {
    countryCode: 'cz',
    name: 'Czech Republic'
  },
  dd: {
    countryCode: 'dd',
    name: 'East Germany'
  },
  de: {
    carriers: [
      {
        code: ['262-01', '262-06', '262-78'],
        name: 'Telekom'
      },
      {
        code: ['262-02', '262-04', '262-09'],
        name: 'Vodafone'
      },
      {
        code: ['262-03', '262-05', '262-17', '262-77'],
        name: 'E-Plus'
      },
      {
        code: ['262-07', '262-08', '262-11'],
        name: 'O2'
      },
      {
        code: ['262-12'],
        name: 'Dolphin Telecom'
      },
      {
        code: ['262-15'],
        name: 'Airdata'
      },
      {
        code: ['262-20'],
        name: 'OnePhone'
      },
      {
        code: ['262-33'],
        name: 'simquadrat'
      },
      {
        code: ['262-42'],
        name: 'CCC Event'
      },
      {
        code: ['262-43'],
        name: 'LYCA'
      },
      {
        code: ['262-901'],
        name: 'Debitel'
      }
    ],
    countryCode: 'de',
    name: 'Germany',
    regions: {
      de01: {
        factualCode: 'NORDRHEIN-WESTFALEN',
        name: 'Nordrhein-Westfalen'
      },
      de02: {
        factualCode: 'BAYERN',
        name: 'Bayern'
      },
      de03: {
        factualCode: 'BADEN-WÜRTTEMBERG',
        name: 'Baden-Württemberg'
      },
      de04: {
        factualCode: 'NIEDERSACHSEN',
        name: 'Niedersachsen'
      },
      de05: {
        factualCode: 'HESSEN',
        name: 'Hassen'
      },
      de06: {
        factualCode: 'SACHSEN',
        name: 'Sachsen'
      },
      de07: {
        factualCode: 'RHEINLAND-PFALZ',
        name: 'Rheinland-Pfalz'
      },
      de08: {
        factualCode: 'BERLIN',
        name: 'Berlin'
      },
      de09: {
        factualCode: 'SCHLESWIG-HOLSTEIN',
        name: 'Schleswig-Holstein'
      },
      de10: {
        factualCode: 'HAMBURG',
        name: 'Hamburg'
      },
      de11: {
        factualCode: 'BRANDENBURG',
        name: 'Brandenburg'
      },
      de12: {
        factualCode: 'THÜRINGEN',
        name: 'Thüringen'
      },
      de13: {
        factualCode: 'SACHSEN-ANHALT',
        name: 'Sachsen-Anhalt'
      },
      de14: {
        factualCode: 'MECKLENBURG-VORPOMMERN',
        name: 'Mecklenburg-Vorpommern'
      },
      de15: {
        factualCode: 'SAARLAND',
        name: 'Saarland'
      },
      de16: {
        factualCode: 'BREMEN',
        name: 'Bremen'
      }
    }
  },
  default: {
    countryCode: 'default',
    name: 'Default'
  },
  dh: {
    countryCode: 'dh',
    name: 'Dominica'
  },
  dj: {
    countryCode: 'dj',
    name: 'Djibouti'
  },
  dk: {
    countryCode: 'dk',
    name: 'Denmark'
  },
  do: {
    countryCode: 'do',
    name: 'Dominican Republic'
  },
  dz: {
    countryCode: 'dz',
    name: 'Algeria'
  },
  ec: {
    countryCode: 'ec',
    name: 'Ecuador'
  },
  ee: {
    countryCode: 'ee',
    name: 'Estonia'
  },
  eg: {
    countryCode: 'eg',
    name: 'Egypt'
  },
  eh: {
    countryCode: 'eh',
    name: 'Western Sahara'
  },
  er: {
    countryCode: 'er',
    name: 'Eritrea'
  },
  es: {
    carriers: [
      {
        code: ['214-01'],
        name: 'Vodafone'
      },
      {
        code: ['214-03'],
        name: 'Orange'
      },
      {
        code: ['214-04'],
        name: 'Yoigo'
      },
      {
        code: ['214-05', '214-32'],
        name: 'Tuenti'
      },
      {
        code: ['214-06'],
        name: 'Pepephone'
      },
      {
        code: ['214-07'],
        name: 'Movistar'
      },
      {
        code: ['214-07'],
        name: 'Telefonica'
      },
      {
        code: ['214-08'],
        name: 'Euskaltel'
      },
      {
        code: ['214-11'],
        name: 'Orange'
      },
      {
        code: ['214-15'],
        name: 'BT'
      },
      {
        code: ['214-16'],
        name: 'TeleCable'
      },
      {
        code: ['214-17'],
        name: 'Mobil R'
      },
      {
        code: ['214-18'],
        name: 'ONO'
      },
      {
        code: ['214-19'],
        name: 'Symio'
      },
      {
        code: ['214-20'],
        name: 'Fonyou'
      },
      {
        code: ['214-21'],
        name: 'Jazztel'
      },
      {
        code: ['214-22'],
        name: 'DigiMobil'
      },
      {
        code: ['214-23'],
        name: 'Barablu'
      },
      {
        code: ['214-24'],
        name: 'Eroski'
      },
      {
        code: ['214-25'],
        name: 'Lycamobile'
      },
      {
        code: ['214-27'],
        name: 'Truphone'
      },
      {
        code: ['214-28'],
        name: 'Murcia4G'
      },
      {
        code: ['Amena'],
        name: 'Amena'
      },
      {
        code: ['Masmovil'],
        name: 'Masmovil'
      }
    ],
    countryCode: 'es',
    name: 'Spain',
    regions: {
      a: {
        factualCode: 'ALICANTE',
        name: 'Alicante',
        regionCode: 'a'
      },
      ab: {
        factualCode: 'ALBACETE',
        name: 'Albacete',
        regionCode: 'ab'
      },
      al: {
        factualCode: 'ALMERÍA',
        name: 'Almeria',
        regionCode: 'al'
      },
      av: {
        factualCode: 'ÁVILA',
        name: 'Ávila',
        regionCode: 'av'
      },
      b: {
        factualCode: 'BARCELONA',
        name: 'Barcelona',
        regionCode: 'b'
      },
      ba: {
        factualCode: 'BADAJOZ',
        name: 'Badajoz',
        regionCode: 'ba'
      },
      bi: {
        factualCode: 'VIZCAYA',
        name: 'Vizcaya',
        regionCode: 'bi'
      },
      bu: {
        factualCode: 'BURGOS',
        name: 'Burgos',
        regionCode: 'bu'
      },
      c: {
        factualCode: 'LA CORUÑA',
        name: 'Coruña',
        regionCode: 'c'
      },
      ca: {
        factualCode: 'CÁDIZ',
        name: 'Cadiz',
        regionCode: 'ca'
      },
      cc: {
        factualCode: 'CÁCERES',
        name: 'Cáceres',
        regionCode: 'cc'
      },
      co: {
        factualCode: 'CÓRDOBA',
        name: 'Córdoba',
        regionCode: 'co'
      },
      cr: {
        factualCode: 'CIUDAD REAL',
        name: 'Ciudad Real',
        regionCode: 'cr'
      },
      cs: {
        factualCode: 'CASTELLÓN',
        name: 'Castellón',
        regionCode: 'cs'
      },
      cu: {
        factualCode: 'CUENCA',
        name: 'Cuenca',
        regionCode: 'cu'
      },
      gc: {
        factualCode: 'LAS PALMAS',
        name: 'Las Palmas',
        regionCode: 'gc'
      },
      ge: {
        factualCode: 'GERONA',
        name: 'Gerona',
        regionCode: 'ge'
      },
      gr: {
        factualCode: 'GRANADA',
        name: 'Granada',
        regionCode: 'gr'
      },
      gu: {
        factualCode: 'GUADALAJARA',
        name: 'Guadalajara',
        regionCode: 'gu'
      },
      h: {
        factualCode: 'HUELVA',
        name: 'Huelva',
        regionCode: 'h'
      },
      hu: {
        factualCode: 'HUESCA',
        name: 'Huesca',
        regionCode: 'hu'
      },
      ib: {
        factualCode: 'ISLAS BALEARES',
        name: 'Baleares',
        regionCode: 'ib'
      },
      j: {
        factualCode: 'JAÉN',
        name: 'Jaén',
        regionCode: 'j'
      },
      l: {
        factualCode: 'LÉRIDA',
        name: 'Lérida',
        regionCode: 'l'
      },
      le: {
        factualCode: 'LEÓN',
        name: 'León',
        regionCode: 'le'
      },
      lo: {
        factualCode: 'LA RIOJA',
        name: 'La Rioja',
        regionCode: 'lo'
      },
      lu: {
        factualCode: 'LUGO',
        name: 'Lugo',
        regionCode: 'lu'
      },
      m: {
        factualCode: 'MADRID',
        name: 'Madrid',
        regionCode: 'm'
      },
      ma: {
        factualCode: 'MÁLAGA',
        name: 'Málaga',
        regionCode: 'ma'
      },
      mu: {
        factualCode: 'REGIÓN DE MURCIA',
        name: 'Murcia',
        regionCode: 'mu'
      },
      na: {
        factualCode: 'NAVARRA',
        name: 'Navarra',
        regionCode: 'na'
      },
      o: {
        factualCode: 'PRINCIPADO DE ASTURIAS',
        name: 'Principado de Asturias',
        regionCode: 'o'
      },
      or: {
        factualCode: 'ORENSE',
        name: 'Orense',
        regionCode: 'or'
      },
      p: {
        factualCode: 'PALENCIA',
        name: 'Palencia',
        regionCode: 'p'
      },
      po: {
        factualCode: 'PONTEVEDRA',
        name: 'Pontevedra',
        regionCode: 'po'
      },
      s: {
        factualCode: 'CANTABRIA',
        name: 'Cantabria',
        regionCode: 's'
      },
      sa: {
        factualCode: 'SALAMANCA',
        name: 'Salamanca',
        regionCode: 'sa'
      },
      se: {
        factualCode: 'SEVILLA',
        name: 'Sevilla',
        regionCode: 'se'
      },
      sg: {
        factualCode: 'SEGOVIA',
        name: 'Segovia',
        regionCode: 'sg'
      },
      so: {
        factualCode: 'SORIA',
        name: 'Soria',
        regionCode: 'so'
      },
      ss: {
        factualCode: 'GUIPÚZCOA',
        name: 'Guipúzcoa',
        regionCode: 'ss'
      },
      t: {
        factualCode: 'TARRAGONA',
        name: 'Tarragona',
        regionCode: 't'
      },
      te: {
        factualCode: 'TERUEL',
        name: 'Teruel',
        regionCode: 'te'
      },
      tf: {
        factualCode: 'SANTA CRUZ DE TENERIFE',
        name: 'Santa Cruz de Tenerife',
        regionCode: 'tf'
      },
      to: {
        factualCode: 'TOLEDO',
        name: 'Toledo',
        regionCode: 'to'
      },
      v: {
        factualCode: 'VALENCIA',
        name: 'Valencia',
        regionCode: 'v'
      },
      va: {
        factualCode: 'VALLADOLID',
        name: 'Valladolid',
        regionCode: 'va'
      },
      vi: {
        factualCode: 'ÁLAVA',
        name: 'Álava',
        regionCode: 'vi'
      },
      z: {
        factualCode: 'ZARAGOZA',
        name: 'Zaragoza',
        regionCode: 'z'
      },
      za: {
        factualCode: 'ZAMORA',
        name: 'Zamora',
        regionCode: 'za'
      }
    }
  },
  et: {
    countryCode: 'et',
    name: 'Ethiopia'
  },
  fi: {
    countryCode: 'fi',
    name: 'Finland'
  },
  fj: {
    countryCode: 'fj',
    name: 'Fiji'
  },
  fk: {
    countryCode: 'fk',
    name: 'Falkland Islands'
  },
  fm: {
    countryCode: 'fm',
    name: 'Micronesia'
  },
  fo: {
    countryCode: 'fo',
    name: 'Faroe Islands'
  },
  fq: {
    countryCode: 'fq',
    name: 'French Southern and Antarctic Territories'
  },
  fr: {
    countryCode: 'fr',
    name: 'France',
    regions: {
      fr01: {
        factualCode: 'AIN',
        name: 'Ain'
      },
      fr06: {
        factualCode: 'ALPES-MARITIMES',
        name: 'Alpes-Maritimes'
      },
      fr13: {
        factualCode: 'BOUCHES-DU-RHÔNE',
        name: 'Bouches-du-Rhône'
      },
      fr14: {
        factualCode: 'CALVADOS',
        name: 'Calvados'
      },
      fr17: {
        factualCode: 'CHARENTE-MARITIME',
        name: 'Charente-Maritime'
      },
      fr21: {
        factualCode: "CÔTE-D'OR",
        name: "Côte-d'Or"
      },
      fr22: {
        factualCode: "CÔTES-D'ARMOR",
        name: "Côtes-d'Armor"
      },
      fr24: {
        factualCode: 'DORDOGNE',
        name: 'Dordogne'
      },
      fr25: {
        factualCode: 'DOUBS',
        name: 'Doubs'
      },
      fr26: {
        factualCode: 'DRÔME',
        name: 'Drôme'
      },
      fr29: {
        factualCode: 'FINISTÈRE',
        name: 'Finistère'
      },
      fr30: {
        factualCode: 'GARD',
        name: 'Gard'
      },
      fr31: {
        factualCode: 'HAUTE-GARONNE',
        name: 'Haute-Garonne'
      },
      fr33: {
        factualCode: 'GIRONDE',
        name: 'Gironde'
      },
      fr34: {
        factualCode: 'HÉRAULT',
        name: 'Hérault'
      },
      fr35: {
        factualCode: 'ILLE-ET-VILAINE',
        name: 'Ille et Vilaine'
      },
      fr37: {
        factualCode: 'INDRE-ET-LOIRE',
        name: 'Indre-et-Loire'
      },
      fr38: {
        factualCode: 'ISÈRE',
        name: 'Isère'
      },
      fr42: {
        factualCode: 'LOIRE',
        name: 'Loire'
      },
      fr44: {
        factualCode: 'LOIRE-ATLANTIQUE',
        name: 'Loire-Atlantique'
      },
      fr45: {
        factualCode: 'LOIRET',
        name: 'Loiret'
      },
      fr49: {
        factualCode: 'MAINE-ET-LOIRE',
        name: 'Maine-et-Loire'
      },
      fr51: {
        factualCode: 'MARNE',
        name: 'Marne'
      },
      fr54: {
        factualCode: 'MEURTHE-ET-MOSELLE',
        name: 'Meurthe-et-Moselle'
      },
      fr56: {
        factualCode: 'MORBIHAN',
        name: 'Morbihan'
      },
      fr57: {
        factualCode: 'MOSELLE',
        name: 'Moselle'
      },
      fr59: {
        factualCode: 'NORD',
        name: 'Nord'
      },
      fr60: {
        factualCode: 'OISE',
        name: 'Oise'
      },
      fr62: {
        factualCode: 'PAS-DE-CALAIS',
        name: 'Pas-de-Calais'
      },
      fr63: {
        factualCode: 'PUY-DE-DÔME',
        name: 'Puy-de-Dôme'
      },
      fr64: {
        factualCode: 'PYRÉNÉES-ATLANTIQUES',
        name: 'Pyrénées-Atlantiques'
      },
      fr66: {
        factualCode: 'PYRÉNÉES-ORIENTALES',
        name: 'Pyrénées-Orientales'
      },
      fr67: {
        factualCode: 'BAS-RHIN',
        name: 'Bas-Rhin'
      },
      fr68: {
        factualCode: 'HAUT-RHIN',
        name: 'Haut-Rhin'
      },
      fr69: {
        factualCode: 'RHÔNE',
        name: 'Rhône'
      },
      fr71: {
        factualCode: 'SAÔNE-ET-LOIRE',
        name: 'Saône-et-Loire'
      },
      fr73: {
        factualCode: 'SAVOIE',
        name: 'Savoie'
      },
      fr74: {
        factualCode: 'HAUTE-SAVOIE',
        name: 'Haute-Savoie'
      },
      fr75: {
        factualCode: 'PARIS',
        name: 'Paris'
      },
      fr76: {
        factualCode: 'SEINE-MARITIME',
        name: 'Seine-Maritime'
      },
      fr77: {
        factualCode: 'SEINE-ET-MARNE',
        name: 'Seine-et-Marne'
      },
      fr78: {
        factualCode: 'YVELINES',
        name: 'Yvelines'
      },
      fr83: {
        factualCode: 'VAR',
        name: 'Var'
      },
      fr84: {
        factualCode: 'VAUCLUSE',
        name: 'Vaucluse'
      },
      fr85: {
        factualCode: 'VENDÉE',
        name: 'Vendée'
      },
      fr91: {
        factualCode: 'ESSONNE',
        name: 'Essonne'
      },
      fr92: {
        factualCode: 'HAUTS-DE-SEINE',
        name: 'Hauts-De-Seine'
      },
      fr93: {
        factualCode: 'SEINE-SAINT-DENIS',
        name: 'Seine-Saint-Denis'
      },
      fr94: {
        factualCode: 'VAL-DE-MARNE',
        name: 'Val de Marne'
      },
      fr95: {
        factualCode: "VAL-D'OISE",
        name: "Val-d'Oise"
      }
    }
  },
  fx: {
    countryCode: 'fx',
    name: 'Metropolitan France'
  },
  ga: {
    countryCode: 'ga',
    name: 'Gabon'
  },
  gb: {
    carriers: [
      {
        code: ['234-00', '234-76', '235-77'],
        name: 'BT'
      },
      {
        code: ['234-01'],
        name: 'Vectone Mobile'
      },
      {
        code: ['234-02', '234-10', '234-11'],
        name: 'O2 (UK)'
      },
      {
        code: ['234-03'],
        name: 'Airtel-Vodafone'
      },
      {
        code: ['234-04'],
        name: 'FMS Solutions Ltd'
      },
      {
        code: ['234-12', '234-13'],
        name: 'Railtrack'
      },
      {
        code: ['234-14'],
        name: 'Hay Systems Ltd'
      },
      {
        code: ['234-15'],
        name: 'Vodafone UK'
      },
      {
        code: ['234-16'],
        name: 'Talk Talk'
      },
      {
        code: ['234-18'],
        name: 'Cloud9'
      },
      {
        code: ['234-19'],
        name: 'Private Mobile Networks PMN'
      },
      {
        code: ['234-20'],
        name: '3'
      },
      {
        code: ['234-24'],
        name: 'Greenfone'
      },
      {
        code: ['234-25'],
        name: 'Truphone'
      },
      {
        code: ['234-26'],
        name: 'Lycamobile'
      },
      {
        code: ['234-29'],
        name: 'aql'
      },
      {
        code: ['234-30'],
        name: 'T-Mobile UK'
      },
      {
        code: ['234-31', '234-32', '234-38'],
        name: 'Virgin Mobile UK'
      },
      {
        code: ['234-33', '234-34'],
        name: 'Orange (UK)'
      },
      {
        code: ['234-36', '234-55'],
        name: 'Sure Mobile'
      },
      {
        code: ['234-50'],
        name: 'JT'
      },
      {
        code: ['234-51', '235-03'],
        name: 'UK Broadband'
      },
      {
        code: ['234-58'],
        name: 'Pronto GSM'
      },
      {
        code: ['234-78'],
        name: 'Airwave'
      }
    ],
    countryCode: 'gb',
    name: 'United Kingdom'
  },
  gd: {
    countryCode: 'gd',
    name: 'Grenada'
  },
  ge: {
    countryCode: 'ge',
    name: 'Georgia'
  },
  gf: {
    countryCode: 'gf',
    name: 'French Guiana'
  },
  gg: {
    countryCode: 'gg',
    name: 'Guernsey'
  },
  gh: {
    countryCode: 'gh',
    name: 'Ghana'
  },
  gi: {
    countryCode: 'gi',
    name: 'Gibraltar'
  },
  gl: {
    countryCode: 'gl',
    name: 'Greenland'
  },
  gm: {
    countryCode: 'gm',
    name: 'Gambia'
  },
  gn: {
    countryCode: 'gn',
    name: 'Guinea'
  },
  gp: {
    countryCode: 'gp',
    name: 'Guadeloupe'
  },
  gq: {
    countryCode: 'gq',
    name: 'Equatorial Guinea'
  },
  gr: {
    countryCode: 'gr',
    name: 'Greece'
  },
  gs: {
    countryCode: 'gs',
    name: 'South Georgia and the South Sandwich Islands'
  },
  gt: {
    countryCode: 'gt',
    name: 'Guatemala'
  },
  gu: {
    countryCode: 'gu',
    name: 'Guam'
  },
  gw: {
    countryCode: 'gw',
    name: 'Guinea-Bissau'
  },
  gy: {
    countryCode: 'gy',
    name: 'Guyana'
  },
  hk: {
    countryCode: 'hk',
    name: 'Hong Kong SAR China'
  },
  hm: {
    countryCode: 'hm',
    name: 'Heard Island and McDonald Islands'
  },
  hn: {
    countryCode: 'hn',
    name: 'Honduras'
  },
  hr: {
    countryCode: 'hr',
    name: 'Croatia'
  },
  ht: {
    countryCode: 'ht',
    name: 'Haiti'
  },
  hu: {
    countryCode: 'hu',
    name: 'Hungary'
  },
  id: {
    countryCode: 'id',
    name: 'Indonesia'
  },
  ie: {
    countryCode: 'ie',
    name: 'Ireland'
  },
  il: {
    countryCode: 'il',
    name: 'Israel'
  },
  im: {
    countryCode: 'im',
    name: 'Isle of Man'
  },
  in: {
    carriers: [
      {
        code: [
          '404-01',
          '404-05',
          '404-11',
          '404-13',
          '404-15',
          '404-20',
          '404-27',
          '404-30',
          '404-43',
          '404-46',
          '404-60',
          '404-84',
          '404-86',
          '404-88',
          '405-66',
          '405-67',
          '405-750',
          '405-751',
          '405-752',
          '405-753',
          '405-754',
          '405-755',
          '405-756'
        ],
        name: 'Vodafone IN'
      },
      {
        code: [
          '404-02',
          '404-03',
          '404-10',
          '404-31',
          '404-40',
          '404-70',
          '404-90',
          '404-92',
          '404-93',
          '404-94',
          '404-95',
          '404-96',
          '404-97',
          '404-98',
          '405-51',
          '405-52',
          '405-53',
          '405-54',
          '405-56'
        ],
        name: 'AirTel'
      },
      {
        code: [
          '404-04',
          '404-07',
          '404-12',
          '404-14',
          '404-19',
          '404-22',
          '404-24',
          '404-44',
          '404-56',
          '404-87',
          '405-70',
          '405-799',
          '405-845',
          '405-846',
          '405-847',
          '405-848',
          '405-849',
          '405-850',
          '405-851',
          '405-852',
          '405-853',
          '405-908',
          '405-909',
          '405-910',
          '405-911'
        ],
        name: 'IDEA'
      },
      {
        code: [
          '404-09',
          '404-18',
          '404-36',
          '404-50',
          '404-52',
          '404-67',
          '404-83',
          '404-85',
          '405-01',
          '405-03',
          '405-04',
          '405-05',
          '405-06',
          '405-07',
          '405-08',
          '405-09',
          '405-10',
          '405-11',
          '405-12',
          '405-13',
          '405-14',
          '405-15',
          '405-17',
          '405-18',
          '405-19',
          '405-20',
          '405-21',
          '405-22',
          '405-23'
        ],
        name: 'Reliance'
      },
      {
        code: ['404-16', '404-45', '404-49', '405-55'],
        name: 'Airtel'
      },
      {
        code: [
          '404-17',
          '404-25',
          '404-28',
          '404-29',
          '404-91',
          '405-800',
          '405-801',
          '405-802',
          '405-803',
          '405-804',
          '405-805',
          '405-806',
          '405-807',
          '405-808',
          '405-809',
          '405-810',
          '405-811',
          '405-812'
        ],
        name: 'AIRCEL'
      },
      {
        code: ['404-21'],
        name: 'Loop Mobile'
      },
      {
        code: [
          '404-34',
          '404-38',
          '404-51',
          '404-53',
          '404-54',
          '404-55',
          '404-57',
          '404-58',
          '404-59',
          '404-62',
          '404-64',
          '404-66',
          '404-71',
          '404-72',
          '404-73',
          '404-74',
          '404-75',
          '404-76',
          '404-77',
          '404-79',
          '404-80',
          '404-81'
        ],
        name: 'CellOne'
      },
      {
        code: ['404-37', '404-41', '404-42'],
        name: 'Aircel'
      },
      {
        code: ['404-48'],
        name: 'Dishnet Wireless'
      },
      {
        code: ['404-68', '404-69'],
        name: 'DOLPHIN'
      },
      {
        code: ['404-78'],
        name: 'Idea Cellular Ltd'
      },
      {
        code: ['404-82', '404-89'],
        name: 'Idea'
      },
      {
        code: [
          '405-025',
          '405-026',
          '405-027',
          '405-028',
          '405-029',
          '405-030',
          '405-031',
          '405-032',
          '405-033',
          '405-034',
          '405-035',
          '405-036',
          '405-037',
          '405-038',
          '405-039',
          '405-041',
          '405-042',
          '405-043',
          '405-044',
          '405-045',
          '405-046',
          '405-047'
        ],
        name: 'TATA DOCOMO'
      },
      {
        code: [
          '405-819',
          '405-818',
          '405-820',
          '405-821',
          '405-880',
          '405-822',
          '405-844',
          '405-875',
          '405-927',
          '405-929'
        ],
        name: 'Uninor'
      },
      {
        code: ['405-824', '405-827', '405-834'],
        name: 'Videocon Datacom'
      },
      {
        code: [
          '405-840',
          '405-854',
          '405-855',
          '405-856',
          '405-857',
          '405-858',
          '405-859',
          '405-860',
          '405-861',
          '405-862',
          '405-863',
          '405-864',
          '405-865',
          '405-866',
          '405-867',
          '405-868',
          '405-869',
          '405-870',
          '405-871',
          '405-872',
          '405-873',
          '405-874'
        ],
        name: 'Jio'
      },
      {
        code: ['405-881'],
        name: 'S Tel'
      },
      {
        code: ['405-912', '405-913', '405-914', '405-917'],
        name: 'Etisalat DB(cheers)'
      }
    ],
    countryCode: 'in',
    name: 'India',
    regions: {
      in0: { factualCode: 'MAHARASHTRA', name: 'Maharashtra' },
      in1: { factualCode: 'TAMIL NADU', name: 'Tamil Nadu' },
      in10: { factualCode: 'PUNJAB', name: 'Punjab' },
      in11: { factualCode: 'HARYANA', name: 'Haryana' },
      in12: { factualCode: 'MADHYA PRADESH', name: 'Madhya Pradesh' },
      in13: { factualCode: 'CHANDIGARH', name: 'Chandigarh' },
      in14: { factualCode: 'GOA', name: 'Goa' },
      in15: { factualCode: 'ORISSA', name: 'Orissa' },
      in16: { factualCode: 'CHHATTISGARH', name: 'Chhattisgarh' },
      in17: { factualCode: 'BIHAR', name: 'Bihar' },
      in18: { factualCode: 'UTTARANCHAL', name: 'Uttaranchal' },
      in19: { factualCode: 'TAMILNADU', name: 'Tamilnadu' },
      in2: { factualCode: 'KARNATAKA', name: 'Karnataka' },
      in20: { factualCode: 'JHARKHAND', name: 'Jharkhand' },
      in21: { factualCode: 'ASSAM', name: 'Assam' },
      in22: { factualCode: 'HIMACHAL PRADESH', name: 'Himachal Pradesh' },
      in23: { factualCode: 'PONDICHERRY', name: 'Pondicherry' },
      in24: { factualCode: 'JAMMU AND KASHMIR', name: 'Jammu And Kashmir' },
      in25: { factualCode: 'JAMMU & KASHMIR', name: 'Jammu & Kashmir' },
      in26: { factualCode: 'SIKKIM', name: 'Sikkim' },
      in27: { factualCode: 'PUDUCHERRY', name: 'Puducherry' },
      in28: { factualCode: 'NAGALAND', name: 'Nagaland' },
      in29: { factualCode: 'MEGHALAYA', name: 'Meghalaya' },
      in3: { factualCode: 'GUJARAT', name: 'Gujarat' },
      in30: { factualCode: 'DAMAN & DIU', name: 'Daman & Diu' },
      in31: { factualCode: 'TRIPURA', name: 'Tripura' },
      in32: { factualCode: 'ANDAMAN & NICOBAR ISLANDS', name: 'Andaman & Nicobar Islands' },
      in33: { factualCode: 'MANIPUR', name: 'Manipur' },
      in34: { factualCode: 'DAMAN AND DIU', name: 'Daman And Diu' },
      in35: { factualCode: 'ANDAMAN AND NICOBAR', name: 'Andaman And Nicobar' },
      in36: { factualCode: 'DADRA AND NAGAR HAVELI', name: 'Dadra And Nagar Haveli' },
      in37: { factualCode: 'MIZORAM', name: 'Mizoram' },
      in38: { factualCode: 'ARUNACHAL PRADESH', name: 'Arunachal Pradesh' },
      in39: { factualCode: 'DADRA & NAGAR HAVELI', name: 'Dadra & Nagar Haveli' },
      in4: { factualCode: 'DELHI', name: 'Delhi' },
      in40: { factualCode: 'LAKSHADWEEP', name: 'Lakshadweep' },
      in41: { factualCode: 'HIMANCHAL PRADESH', name: 'Himanchal Pradesh' },
      in5: { factualCode: 'UTTAR PRADESH', name: 'Uttar Pradesh' },
      in6: { factualCode: 'ANDHRA PRADESH', name: 'Andhra Pradesh' },
      in7: { factualCode: 'WEST BENGAL', name: 'West Bengal' },
      in8: { factualCode: 'RAJASTHAN', name: 'Rajasthan' },
      in9: { factualCode: 'KERALA', name: 'Kerala' }
    }
  },
  io: {
    countryCode: 'io',
    name: 'British Indian Ocean Territory'
  },
  iq: {
    countryCode: 'iq',
    name: 'Iraq'
  },
  ir: {
    countryCode: 'ir',
    name: 'Iran'
  },
  is: {
    countryCode: 'is',
    name: 'Iceland'
  },
  it: {
    carriers: [
      {
        code: ['222-01', '222-43', '222-48'],
        name: 'TIM'
      },
      {
        code: ['222-02'],
        name: 'Elsacom'
      },
      {
        code: ['222-04'],
        name: 'Intermatica'
      },
      {
        code: ['222-05'],
        name: 'Telespazio'
      },
      {
        code: ['222-06', '222-10'],
        name: 'Vodafone'
      },
      {
        code: ['222-07'],
        name: 'Noverca'
      },
      {
        code: ['222-30'],
        name: 'RFI'
      },
      {
        code: ['222-33'],
        name: 'Poste Mobile'
      },
      {
        code: ['222-34'],
        name: 'BT Italia'
      },
      {
        code: ['222-35'],
        name: 'Lyca Italy'
      },
      {
        code: ['222-36'],
        name: 'Digi Mobil'
      },
      {
        code: ['222-37', '222-99'],
        name: '3 Italia'
      },
      {
        code: ['222-38'],
        name: 'LINKEM'
      },
      {
        code: ['222-39'],
        name: 'SMS Italia'
      },
      {
        code: ['222-77'],
        name: 'IPSE 2000'
      },
      {
        code: ['222-88'],
        name: 'Wind'
      },
      {
        code: ['222-98'],
        name: 'BLU s.p.a'
      }
    ],
    countryCode: 'it',
    name: 'Italy',
    regions: {
      al: {
        factualCode: 'ALESSANDRIA',
        name: 'Alessandria'
      },
      an: {
        factualCode: 'ANCONA',
        name: 'Ancona'
      },
      ar: {
        factualCode: 'AREZZO',
        name: 'Arezzo'
      },
      ba: {
        factualCode: 'BARI',
        name: 'Bari'
      },
      bg: {
        factualCode: 'BERGAMO',
        name: 'Bergamo'
      },
      bo: {
        factualCode: 'BOLOGNA',
        name: 'Bologna'
      },
      bs: {
        factualCode: 'BRESCIA',
        name: 'Brescia'
      },
      bz: {
        factualCode: 'BOLZANO',
        name: 'Bolzano'
      },
      ca: {
        factualCode: 'CAGLIARI',
        name: 'Cagliari'
      },
      ce: {
        factualCode: 'CASERTA',
        name: 'Caserta'
      },
      cn: {
        factualCode: 'CUNEO',
        name: 'Cuneo'
      },
      co: {
        factualCode: 'COMO',
        name: 'Como'
      },
      cs: {
        factualCode: 'COSENZA',
        name: 'Cosenza'
      },
      ct: {
        factualCode: 'CATANIA',
        name: 'Catania'
      },
      fg: {
        factualCode: 'FOGGIA',
        name: 'Foggia'
      },
      fi: {
        factualCode: 'FIRENZE',
        name: 'Firenze'
      },
      fo: {
        factualCode: 'FORLÌ-CESENA',
        name: 'Forlì-Cesena'
      },
      ge: {
        factualCode: 'GENOVA',
        name: 'Genova'
      },
      le: {
        factualCode: 'LECCE',
        name: 'Lecce'
      },
      li: {
        factualCode: 'LIVORNO',
        name: 'Livorno'
      },
      lt: {
        factualCode: 'LATINA',
        name: 'Latina'
      },
      lu: {
        factualCode: 'LUCCA',
        name: 'Lucca'
      },
      mb: {
        factualCode: 'MONZA E BRIANZA',
        name: 'Monza e Brianza'
      },
      mc: {
        factualCode: 'MACERATA',
        name: 'Macerata'
      },
      me: {
        factualCode: 'MESSINA',
        name: 'Messina'
      },
      mi: {
        factualCode: 'MILANO',
        name: 'Milano'
      },
      mn: {
        factualCode: 'MANTOVA',
        name: 'Mantova'
      },
      mo: {
        factualCode: 'MODENA',
        name: 'Modena'
      },
      na: {
        factualCode: 'NAPOLI',
        name: 'Napoli'
      },
      pa: {
        factualCode: 'PALERMO',
        name: 'Palermo'
      },
      pd: {
        factualCode: 'PADOVA',
        name: 'Padova'
      },
      pg: {
        factualCode: 'PERUGIA',
        name: 'Perugia'
      },
      pi: {
        factualCode: 'PISA',
        name: 'Pisa'
      },
      pr: {
        factualCode: 'PARMA',
        name: 'Parma'
      },
      ps: {
        factualCode: 'PESARO E URBINO',
        name: 'Pesaro e Urbino'
      },
      pv: {
        factualCode: 'PAVIA',
        name: 'Pavia'
      },
      ra: {
        factualCode: 'RAVENNA',
        name: 'Ravenna'
      },
      re: {
        factualCode: 'REGGIO EMILIA',
        name: 'Reggio Emilia'
      },
      rm: {
        factualCode: 'ROMA',
        name: 'Roma'
      },
      rn: {
        factualCode: 'RIMINI',
        name: 'Rimini'
      },
      sa: {
        factualCode: 'SALERNO',
        name: 'Salerno'
      },
      si: {
        factualCode: 'SIENA',
        name: 'Siena'
      },
      tn: {
        factualCode: 'TRENTO',
        name: 'Trento'
      },
      to: {
        factualCode: 'TORINO',
        name: 'Torino'
      },
      tr: {
        factualCode: 'TREVISO',
        name: 'Treviso'
      },
      ud: {
        factualCode: 'UDINE',
        name: 'Udine'
      },
      va: {
        factualCode: 'VARESE',
        name: 'Varese'
      },
      ve: {
        factualCode: 'VENEZIA',
        name: 'Venezia'
      },
      vi: {
        factualCode: 'VICENZA',
        name: 'Vicenza'
      },
      vr: {
        factualCode: 'VERONA',
        name: 'Verona'
      }
    }
  },
  je: {
    countryCode: 'je',
    name: 'Jersey'
  },
  jm: {
    countryCode: 'jm',
    name: 'Jamaica'
  },
  jo: {
    countryCode: 'jo',
    name: 'Jordan'
  },
  jp: {
    countryCode: 'jp',
    name: 'Japan',
    regions: {
      jp0: { factualCode: '東京都', name: '東京都' },
      jp1: { factualCode: '大阪府', name: '大阪府' },
      jp10: { factualCode: '広島県', name: '広島県' },
      jp11: { factualCode: '長野県', name: '長野県' },
      jp12: { factualCode: '茨城県', name: '茨城県' },
      jp13: { factualCode: '新潟県', name: '新潟県' },
      jp14: { factualCode: '京都府', name: '京都府' },
      jp15: { factualCode: '岐阜県', name: '岐阜県' },
      jp16: { factualCode: '宮城県', name: '宮城県' },
      jp17: { factualCode: '福島県', name: '福島県' },
      jp18: { factualCode: '群馬県', name: '群馬県' },
      jp19: { factualCode: '栃木県', name: '栃木県' },
      jp2: { factualCode: '愛知県', name: '愛知県' },
      jp20: { factualCode: '岡山県', name: '岡山県' },
      jp21: { factualCode: '三重県', name: '三重県' },
      jp22: { factualCode: '熊本県', name: '熊本県' },
      jp23: { factualCode: '鹿児島県', name: '鹿児島県' },
      jp24: { factualCode: '愛媛県', name: '愛媛県' },
      jp25: { factualCode: '山口県', name: '山口県' },
      jp26: { factualCode: '長崎県', name: '長崎県' },
      jp27: { factualCode: '石川県', name: '石川県' },
      jp28: { factualCode: '沖縄県', name: '沖縄県' },
      jp29: { factualCode: '岩手県', name: '岩手県' },
      jp3: { factualCode: '神奈川県', name: '神奈川県' },
      jp30: { factualCode: '青森県', name: '青森県' },
      jp31: { factualCode: '大分県', name: '大分県' },
      jp32: { factualCode: '山形県', name: '山形県' },
      jp33: { factualCode: '富山県', name: '富山県' },
      jp34: { factualCode: '宮崎県', name: '宮崎県' },
      jp35: { factualCode: '滋賀県', name: '滋賀県' },
      jp36: { factualCode: '香川県', name: '香川県' },
      jp37: { factualCode: '秋田県', name: '秋田県' },
      jp38: { factualCode: '奈良県', name: '奈良県' },
      jp39: { factualCode: '福井県', name: '福井県' },
      jp4: { factualCode: '北海道', name: '北海道' },
      jp40: { factualCode: '山梨県', name: '山梨県' },
      jp41: { factualCode: '和歌山県', name: '和歌山県' },
      jp42: { factualCode: '高知県', name: '高知県' },
      jp43: { factualCode: '佐賀県', name: '佐賀県' },
      jp44: { factualCode: '徳島県', name: '徳島県' },
      jp45: { factualCode: '島根県', name: '島根県' },
      jp46: { factualCode: '鳥取県', name: '鳥取県' },
      jp5: { factualCode: '福岡県', name: '福岡県' },
      jp6: { factualCode: '埼玉県', name: '埼玉県' },
      jp7: { factualCode: '兵庫県', name: '兵庫県' },
      jp8: { factualCode: '千葉県', name: '千葉県' },
      jp9: { factualCode: '静岡県', name: '静岡県' }
    }
  },
  jt: {
    countryCode: 'jt',
    name: 'Johnston Island'
  },
  ke: {
    countryCode: 'ke',
    name: 'Kenya'
  },
  kg: {
    countryCode: 'kg',
    name: 'Kyrgyzstan'
  },
  kh: {
    countryCode: 'kh',
    name: 'Cambodia'
  },
  ki: {
    countryCode: 'ki',
    name: 'Kiribati'
  },
  km: {
    countryCode: 'km',
    name: 'Comoros'
  },
  kn: {
    countryCode: 'kn',
    name: 'Saint Kitts and Nevis'
  },
  kp: {
    countryCode: 'kp',
    name: 'North Korea'
  },
  kr: {
    countryCode: 'kr',
    name: 'South Korea'
  },
  kw: {
    countryCode: 'kw',
    name: 'Kuwait'
  },
  ky: {
    countryCode: 'ky',
    name: 'Cayman Islands'
  },
  kz: {
    countryCode: 'kz',
    name: 'Kazakhstan'
  },
  la: {
    countryCode: 'la',
    name: 'Laos'
  },
  lb: {
    countryCode: 'lb',
    name: 'Lebanon'
  },
  lc: {
    countryCode: 'lc',
    name: 'Saint Lucia'
  },
  li: {
    countryCode: 'li',
    name: 'Liechtenstein'
  },
  lk: {
    countryCode: 'lk',
    name: 'Sri Lanka'
  },
  lr: {
    countryCode: 'lr',
    name: 'Liberia'
  },
  ls: {
    countryCode: 'ls',
    name: 'Lesotho'
  },
  lt: {
    countryCode: 'lt',
    name: 'Lithuania'
  },
  lu: {
    countryCode: 'lu',
    name: 'Luxembourg'
  },
  lv: {
    countryCode: 'lv',
    name: 'Latvia'
  },
  ly: {
    countryCode: 'ly',
    name: 'Libya'
  },
  ma: {
    countryCode: 'ma',
    name: 'Morocco'
  },
  mc: {
    countryCode: 'mc',
    name: 'Monaco'
  },
  md: {
    countryCode: 'md',
    name: 'Moldova'
  },
  me: {
    countryCode: 'me',
    name: 'Montenegro'
  },
  mf: {
    countryCode: 'mf',
    name: 'Saint Martin'
  },
  mg: {
    countryCode: 'mg',
    name: 'Madagascar'
  },
  mh: {
    countryCode: 'mh',
    name: 'Marshall Islands'
  },
  mi: {
    countryCode: 'mi',
    name: 'Midway Islands'
  },
  mk: {
    countryCode: 'mk',
    name: 'Macedonia'
  },
  ml: {
    countryCode: 'ml',
    name: 'Mali'
  },
  mm: {
    countryCode: 'mm',
    name: 'Myanmar [Burma]'
  },
  mn: {
    countryCode: 'mn',
    name: 'Mongolia'
  },
  mo: {
    countryCode: 'mo',
    name: 'Macau SAR China'
  },
  mp: {
    countryCode: 'mp',
    name: 'Northern Mariana Islands'
  },
  mq: {
    countryCode: 'mq',
    name: 'Martinique'
  },
  mr: {
    countryCode: 'mr',
    name: 'Mauritania'
  },
  ms: {
    countryCode: 'ms',
    name: 'Montserrat'
  },
  mt: {
    countryCode: 'mt',
    name: 'Malta'
  },
  mu: {
    countryCode: 'mu',
    name: 'Mauritius'
  },
  mv: {
    countryCode: 'mv',
    name: 'Maldives'
  },
  mw: {
    countryCode: 'mw',
    name: 'Malawi'
  },
  mx: {
    carriers: [
      {
        code: ['334-010', '334-090'],
        name: 'Nextel'
      },
      {
        code: ['334-020'],
        name: 'Telcel'
      },
      {
        code: ['334-030'],
        name: 'movistar'
      },
      {
        code: ['334-040'],
        name: 'Iusacell / Unefon'
      },
      {
        code: ['334-050'],
        name: 'Iusacell'
      }
    ],
    countryCode: 'mx',
    name: 'Mexico',
    regions: {
      agu: {
        factualCode: 'AGUASCALIENTES',
        name: 'Aguascalientes'
      },
      bcn: {
        factualCode: 'BAJA CALIFORNIA',
        name: 'Baja California'
      },
      bcs: {
        factualCode: 'BAJA CALIFORNIA SUR',
        name: 'Baja California Sur'
      },
      cam: {
        factualCode: 'CAMPECHE',
        name: 'Campeche'
      },
      chh: {
        factualCode: 'CHIHUAHUA',
        name: 'Chihuahua'
      },
      chp: {
        factualCode: 'CHIAPAS',
        name: 'Chiapas'
      },
      cmx: {
        factualCode: 'CIUDAD DE MÉXICO',
        name: 'Ciudad de México'
      },
      coa: {
        factualCode: 'COAHUILA',
        name: 'Coahuila'
      },
      col: {
        factualCode: 'COLIMA',
        name: 'Colima'
      },
      dur: {
        factualCode: 'DURANGO',
        name: 'Durango'
      },
      gro: {
        factualCode: 'GUERRERO',
        name: 'Guerrero'
      },
      gua: {
        factualCode: 'GUANAJUATO',
        name: 'Guanajuato'
      },
      hid: {
        factualCode: 'HIDALGO',
        name: 'Hidalgo'
      },
      jal: {
        factualCode: 'JALISCO',
        name: 'Jalisco'
      },
      mex: {
        factualCode: 'ESTADO DE MÉXICO',
        name: 'Estado de México'
      },
      mic: {
        factualCode: 'MICHOACÁN',
        name: 'Michoacán'
      },
      mor: {
        factualCode: 'MORELOS',
        name: 'Morelos'
      },
      nay: {
        factualCode: 'NAYARIT',
        name: 'Nayarit'
      },
      nle: {
        factualCode: 'NUEVO LEÓN',
        name: 'Nuevo León'
      },
      oax: {
        factualCode: 'OAXACA',
        name: 'Oaxaca'
      },
      pue: {
        factualCode: 'PUEBLA',
        name: 'Puebla'
      },
      que: {
        factualCode: 'QUERÉTARO',
        name: 'Querétaro'
      },
      roo: {
        factualCode: 'QUINTANA ROO',
        name: 'Quintana Roo'
      },
      sin: {
        factualCode: 'SINALOA',
        name: 'Sinaloa'
      },
      slp: {
        factualCode: 'SAN LUIS POTOSÍ',
        name: 'San Luis Potosí'
      },
      son: {
        factualCode: 'SONORA',
        name: 'Sonora'
      },
      tab: {
        factualCode: 'TABASCO',
        name: 'Tabasco'
      },
      tam: {
        factualCode: 'TAMAULIPAS',
        name: 'Tamaulipas'
      },
      tla: {
        factualCode: 'TLAXCALA',
        name: 'Tlaxcala'
      },
      ver: {
        factualCode: 'VERACRUZ',
        name: 'Veracruz'
      },
      yec: {
        factualCode: 'YUCATÁN',
        name: 'Yucatán'
      },
      zac: {
        factualCode: 'ZACATECAS',
        name: 'Zacatecas'
      }
    }
  },
  my: {
    countryCode: 'my',
    name: 'Malaysia'
  },
  mz: {
    countryCode: 'mz',
    name: 'Mozambique'
  },
  na: {
    countryCode: 'na',
    name: 'Namibia'
  },
  nc: {
    countryCode: 'nc',
    name: 'New Caledonia'
  },
  ne: {
    countryCode: 'ne',
    name: 'Niger'
  },
  nf: {
    countryCode: 'nf',
    name: 'Norfolk Island'
  },
  ng: {
    countryCode: 'ng',
    name: 'Nigeria'
  },
  ni: {
    countryCode: 'ni',
    name: 'Nicaragua'
  },
  nl: {
    carriers: [
      {
        code: ['204-02'],
        name: 'Tele2'
      },
      {
        code: ['204-03'],
        name: 'Voiceworks'
      },
      {
        code: ['204-04'],
        name: 'Vodafone'
      },
      {
        code: ['204-06'],
        name: 'Vectone Mobile / Delight Mobile'
      },
      {
        code: ['204-08', '204-10'],
        name: 'KPN'
      },
      {
        code: ['204-12'],
        name: 'Telfort'
      },
      {
        code: ['204-09'],
        name: 'Lycamobile'
      },
      {
        code: ['204-15'],
        name: 'Ziggo'
      },
      {
        code: ['204-16'],
        name: 'T-Mobile (BEN)'
      },
      {
        code: ['204-17'],
        name: 'Intercity Zakelijk'
      },
      {
        code: ['204-20'],
        name: 'T-Mobile'
      },
      {
        code: ['204-62'],
        name: 'Voxbone'
      }
    ],
    countryCode: 'nl',
    name: 'Netherlands'
  },
  no: {
    countryCode: 'no',
    name: 'Norway'
  },
  np: {
    countryCode: 'np',
    name: 'Nepal'
  },
  nq: {
    countryCode: 'nq',
    name: 'Dronning Maud Land'
  },
  nr: {
    countryCode: 'nr',
    name: 'Nauru'
  },
  nt: {
    countryCode: 'nt',
    name: 'Neutral Zone'
  },
  nu: {
    countryCode: 'nu',
    name: 'Niue'
  },
  nz: {
    countryCode: 'nz',
    name: 'New Zealand'
  },
  om: {
    countryCode: 'om',
    name: 'Oman'
  },
  pa: {
    carriers: [
      {
        code: ['714-01'],
        name: 'Cable & Wireless'
      },
      {
        code: ['714-02'],
        name: 'Movistar'
      },
      {
        code: ['714-03'],
        name: 'Claro'
      },
      {
        code: ['714-04'],
        name: 'Digicel'
      }
    ],
    countryCode: 'pa',
    name: 'Panama'
  },
  pc: {
    countryCode: 'pc',
    name: 'Pacific Islands Trust Territory'
  },
  pe: {
    carriers: [
      {
        code: ['716-06'],
        name: 'Movistar'
      },
      {
        code: ['716-07', '716-17'],
        name: 'Entel'
      },
      {
        code: ['716-10'],
        name: 'Claro'
      },
      {
        code: ['716-15'],
        name: 'Bitel'
      }
    ],
    countryCode: 'pe',
    name: 'Peru'
  },
  pf: {
    countryCode: 'pf',
    name: 'French Polynesia'
  },
  pg: {
    countryCode: 'pg',
    name: 'Papua New Guinea'
  },
  ph: {
    countryCode: 'ph',
    name: 'Philippines'
  },
  pk: {
    countryCode: 'pk',
    name: 'Pakistan'
  },
  pl: {
    countryCode: 'pl',
    name: 'Poland'
  },
  pm: {
    countryCode: 'pm',
    name: 'Saint Pierre and Miquelon'
  },
  pn: {
    countryCode: 'pn',
    name: 'Pitcairn Islands'
  },
  pr: {
    countryCode: 'pr',
    name: 'Puerto Rico'
  },
  ps: {
    countryCode: 'ps',
    name: 'Palestinian Territories'
  },
  pt: {
    countryCode: 'pt',
    name: 'Portugal'
  },
  pu: {
    countryCode: 'pu',
    name: 'U.S. Miscellaneous Pacific Islands'
  },
  pw: {
    countryCode: 'pw',
    name: 'Palau'
  },
  py: {
    countryCode: 'py',
    name: 'Paraguay'
  },
  pz: {
    countryCode: 'pz',
    name: 'Panama Canal Zone'
  },
  qa: {
    countryCode: 'qa',
    name: 'Qatar'
  },
  re: {
    countryCode: 're',
    name: 'Réunion'
  },
  ro: {
    countryCode: 'ro',
    name: 'Romania'
  },
  rs: {
    countryCode: 'rs',
    name: 'Serbia'
  },
  ru: {
    countryCode: 'ru',
    name: 'Russia'
  },
  rw: {
    countryCode: 'rw',
    name: 'Rwanda'
  },
  sa: {
    countryCode: 'sa',
    name: 'Saudi Arabia'
  },
  sb: {
    countryCode: 'sb',
    name: 'Solomon Islands'
  },
  sc: {
    countryCode: 'sc',
    name: 'Seychelles'
  },
  sd: {
    countryCode: 'sd',
    name: 'Sudan'
  },
  se: {
    countryCode: 'se',
    name: 'Sweden'
  },
  sg: {
    countryCode: 'sg',
    name: 'Singapore'
  },
  sh: {
    countryCode: 'sh',
    name: 'Saint Helena'
  },
  si: {
    countryCode: 'si',
    name: 'Slovenia'
  },
  sj: {
    countryCode: 'sj',
    name: 'Svalbard and Jan Mayen'
  },
  sk: {
    countryCode: 'sk',
    name: 'Slovakia'
  },
  sl: {
    countryCode: 'sl',
    name: 'Sierra Leone'
  },
  sm: {
    countryCode: 'sm',
    name: 'San Marino'
  },
  sn: {
    countryCode: 'sn',
    name: 'Senegal'
  },
  so: {
    countryCode: 'so',
    name: 'Somalia'
  },
  sr: {
    countryCode: 'sr',
    name: 'Suriname'
  },
  st: {
    countryCode: 'st',
    name: 'São Tomé and Príncipe'
  },
  su: {
    countryCode: 'su',
    name: 'Union of Soviet Socialist Republics'
  },
  sv: {
    countryCode: 'sv',
    name: 'El Salvador'
  },
  sy: {
    countryCode: 'sy',
    name: 'Syria'
  },
  sz: {
    countryCode: 'sz',
    name: 'Swaziland'
  },
  tc: {
    countryCode: 'tc',
    name: 'Turks and Caicos Islands'
  },
  td: {
    countryCode: 'td',
    name: 'Chad'
  },
  tf: {
    countryCode: 'tf',
    name: 'French Southern Territories'
  },
  tg: {
    countryCode: 'tg',
    name: 'Togo'
  },
  th: {
    countryCode: 'th',
    name: 'Thailand'
  },
  tj: {
    countryCode: 'tj',
    name: 'Tajikistan'
  },
  tk: {
    countryCode: 'tk',
    name: 'Tokelau'
  },
  tl: {
    countryCode: 'tl',
    name: 'Timor-Leste'
  },
  tm: {
    countryCode: 'tm',
    name: 'Turkmenistan'
  },
  tn: {
    countryCode: 'tn',
    name: 'Tunisia'
  },
  to: {
    countryCode: 'to',
    name: 'Tonga'
  },
  tr: {
    countryCode: 'tr',
    name: 'Turkey'
  },
  tt: {
    countryCode: 'tt',
    name: 'Trinidad and Tobago'
  },
  tv: {
    countryCode: 'tv',
    name: 'Tuvalu'
  },
  tw: {
    countryCode: 'tw',
    name: 'Taiwan'
  },
  tz: {
    countryCode: 'tz',
    name: 'Tanzania'
  },
  ua: {
    countryCode: 'ua',
    name: 'Ukraine'
  },
  ug: {
    countryCode: 'ug',
    name: 'Uganda'
  },
  um: {
    countryCode: 'um',
    name: 'U.S. Minor Outlying Islands'
  },
  us: {
    carriers: [
      {
        code: [
          '310-004',
          '310-005',
          '310-006',
          '310-012',
          '311-012',
          '311-480',
          '311-481',
          '311-482',
          '311-483',
          '311-484',
          '311-485',
          '311-486',
          '311-487',
          '311-488',
          '311-489'
        ],
        name: 'Verizon'
      },
      {
        code: ['310-013'],
        name: 'MobileTel'
      },
      {
        code: ['310-016', '310-090'],
        name: 'Cricket Communications'
      },
      {
        code: ['310-026', '310-160', '310-330', '310-490', '310-580', '310-660'],
        name: 'T-Mobile'
      },
      {
        code: ['310-030', '310-150', '310-170', '310-280', '310-380', '310-410', '310-560', '310-680', '310-990'],
        name: 'AT&T'
      },
      {
        code: ['310-034'],
        name: 'Airpeak'
      },
      {
        code: ['310-040'],
        name: 'Concho'
      },
      {
        code: ['310-046'],
        name: 'SIMMETRY'
      },
      {
        code: ['310-066', '311-220', '311-580'],
        name: 'U.S. Cellular'
      },
      {
        code: ['310-080'],
        name: 'Corr'
      },
      {
        code: ['310-100', '310-960'],
        name: 'Plateau Wireless'
      },
      {
        code: ['310-110'],
        name: 'PTI Pacifica'
      },
      {
        code: ['310-120'],
        name: 'Sprint'
      },
      {
        code: ['310-130'],
        name: 'Carolina Wireless'
      },
      {
        code: ['310-180'],
        name: 'West Central'
      },
      {
        code: ['310-190'],
        name: 'Dutch Harbor'
      },
      {
        code: ['310-260'],
        name: 'T-Mobile USA'
      },
      {
        code: ['310-300'],
        name: 'Big Sky Mobile'
      },
      {
        code: ['310-320', '310-440', '310-570'],
        name: 'Cellular One'
      },
      {
        code: ['310-340'],
        name: 'Westlink'
      },
      {
        code: ['310-390'],
        name: 'Cellular One of East Texas'
      },
      {
        code: ['310-400'],
        name: 'i CAN_GSM'
      },
      {
        code: ['310-420'],
        name: 'Cincinnati Bell'
      },
      {
        code: ['310-450'],
        name: 'Viaero'
      },
      {
        code: ['310-460'],
        name: 'Simmetry'
      },
      {
        code: ['310-470'],
        name: 'nTelos'
      },
      {
        code: ['310-500', '310-590'],
        name: 'Alltel'
      },
      {
        code: ['310-510'],
        name: 'Airtel'
      },
      {
        code: ['310-520'],
        name: 'VeriSign'
      },
      {
        code: ['310-540'],
        name: 'Oklahoma Western'
      },
      {
        code: ['310-610'],
        name: 'Epic Touch'
      },
      {
        code: ['310-620'],
        name: 'Coleman County Telecom'
      },
      {
        code: ['310-630'],
        name: 'AmeriLink PCS'
      },
      {
        code: ['310-640'],
        name: 'AirFire'
      },
      {
        code: ['310-650'],
        name: 'Jasper'
      },
      {
        code: ['310-670'],
        name: 'Northstar'
      },
      {
        code: ['310-690'],
        name: 'Immix'
      },
      {
        code: ['310-730'],
        name: 'SeaMobile'
      },
      {
        code: ['310-740'],
        name: 'Convey'
      },
      {
        code: ['310-750'],
        name: 'Appalachian Wireless'
      },
      {
        code: ['310-760'],
        name: 'Panhandle'
      },
      {
        code: ['310-770'],
        name: 'i wireless'
      },
      {
        code: ['310-790'],
        name: 'PinPoint'
      },
      {
        code: ['310-830'],
        name: 'Caprock'
      },
      {
        code: ['310-840'],
        name: 'telna Mobile'
      },
      {
        code: ['310-850'],
        name: 'Aeris'
      },
      {
        code: ['310-870'],
        name: 'PACE'
      },
      {
        code: ['310-880'],
        name: 'DTC Wireless'
      },
      {
        code: ['310-890'],
        name: 'Unicel'
      },
      {
        code: ['310-900'],
        name: 'Mid-Rivers Wireless'
      },
      {
        code: ['310-910'],
        name: 'First Cellular'
      },
      {
        code: ['310-950'],
        name: 'XIT Wireless'
      },
      {
        code: ['310-970'],
        name: 'Globalstar'
      },
      {
        code: ['310-970'],
        name: 'Telemedicine Wireless'
      },
      {
        code: ['310-980'],
        name: 'Akiba Telecommunications, Inc.'
      },
      {
        code: ['311-010'],
        name: 'Chariton Valley'
      },
      {
        code: ['311-060'],
        name: 'Farmers Cellular'
      },
      {
        code: ['311-070'],
        name: 'Easterbrooke'
      },
      {
        code: ['311-080'],
        name: 'Pine Cellular'
      },
      {
        code: ['311-090'],
        name: 'Long Lines Wireless'
      },
      {
        code: ['311-140'],
        name: 'Sprocket'
      },
      {
        code: ['311-170'],
        name: 'PetroCom'
      },
      {
        code: ['311-230'],
        name: 'C Spire Wireless'
      },
      {
        code: ['311-330'],
        name: 'Bug Tussel Wireless'
      },
      {
        code: ['311-370'],
        name: 'GCI Wireless'
      },
      {
        code: ['311-490'],
        name: 'Sprint Corporation'
      },
      {
        code: ['311-530'],
        name: 'PTCI'
      },
      {
        code: ['311-650'],
        name: 'United Wireless'
      },
      {
        code: ['311-660'],
        name: 'metroPCS'
      },
      {
        code: ['311-810'],
        name: 'Bluegrass Wireless'
      },
      {
        code: ['311-870'],
        name: 'Boost'
      },
      {
        code: ['311-950'],
        name: 'ETC'
      },
      {
        code: ['311-960'],
        name: 'Lycamobile'
      },
      {
        code: ['311-970'],
        name: 'Big River Broadband'
      },
      {
        code: ['312-080'],
        name: 'SyncSouth'
      },
      {
        code: ['312-330'],
        name: 'Nemont'
      },
      {
        code: ['312-590'],
        name: 'NMU'
      },
      {
        code: ['313-100'],
        name: 'FirstNet'
      },
      {
        code: ['316-010'],
        name: 'Nextel'
      },
      {
        code: ['316-011'],
        name: 'Southern LINC'
      }
    ],
    countryCode: 'us',
    name: 'United States',
    regions: {
      ak: {
        factualCode: 'ALASKA',
        name: 'Alaska',
        regionCode: 'ak'
      },
      al: {
        factualCode: 'AL',
        name: 'Alabama',
        regionCode: 'al'
      },
      ar: {
        factualCode: 'AR',
        name: 'Arkansas',
        regionCode: 'ar'
      },
      az: {
        factualCode: 'AZ',
        name: 'Arizona',
        regionCode: 'az'
      },
      ca: {
        factualCode: 'CA',
        name: 'California',
        regionCode: 'ca'
      },
      co: {
        factualCode: 'CO',
        name: 'Colorado',
        regionCode: 'co'
      },
      ct: {
        factualCode: 'CT',
        name: 'Connecticut',
        regionCode: 'ct'
      },
      de: {
        factualCode: 'DE',
        name: 'Delaware',
        regionCode: 'de'
      },
      fl: {
        factualCode: 'FL',
        name: 'Florida',
        regionCode: 'fl'
      },
      ga: {
        factualCode: 'GA',
        name: 'Georgia',
        regionCode: 'ga'
      },
      hi: {
        factualCode: 'HI',
        name: 'Hawaii',
        regionCode: 'hi'
      },
      ia: {
        factualCode: 'IA',
        name: 'IOWA',
        regionCode: 'ia'
      },
      id: {
        factualCode: 'ID',
        name: 'Idaho',
        regionCode: 'id'
      },
      il: {
        factualCode: 'IL',
        name: 'Illinois',
        regionCode: 'il'
      },
      in: {
        factualCode: 'IN',
        name: 'Indiana',
        regionCode: 'in'
      },
      ks: {
        factualCode: 'KS',
        name: 'Kansas',
        regionCode: 'ks'
      },
      ky: {
        factualCode: 'KY',
        name: 'Kentucky',
        regionCode: 'ky'
      },
      la: {
        factualCode: 'LA',
        name: 'Louisiana',
        regionCode: 'la'
      },
      ma: {
        factualCode: 'MA',
        name: 'Massachusetts',
        regionCode: 'ma'
      },
      md: {
        factualCode: 'MD',
        name: 'Maryland',
        regionCode: 'md'
      },
      me: {
        factualCode: 'ME',
        name: 'Maine',
        regionCode: 'me'
      },
      mi: {
        factualCode: 'MI',
        name: 'Michigan',
        regionCode: 'mi'
      },
      mn: {
        factualCode: 'MN',
        name: 'Minnesota',
        regionCode: 'mn'
      },
      mo: {
        factualCode: 'MO',
        name: 'Missouri',
        regionCode: 'mo'
      },
      ms: {
        factualCode: 'MS',
        name: 'Mississippi',
        regionCode: 'ms'
      },
      mt: {
        factualCode: 'MT',
        name: 'Montana',
        regionCode: 'mt'
      },
      nc: {
        factualCode: 'NC',
        name: 'North Carolina',
        regionCode: 'nc'
      },
      nd: {
        factualCode: 'ND',
        name: 'North Dakota',
        regionCode: 'nd'
      },
      ne: {
        factualCode: 'NE',
        name: 'Nebraska',
        regionCode: 'ne'
      },
      nh: {
        factualCode: 'NH',
        name: 'New Hampshire',
        regionCode: 'nh'
      },
      nj: {
        factualCode: 'NJ',
        name: 'New Jersey',
        regionCode: 'nj'
      },
      nm: {
        factualCode: 'NM',
        name: 'New Mexico',
        regionCode: 'nm'
      },
      nv: {
        factualCode: 'NV',
        name: 'Nevada',
        regionCode: 'nv'
      },
      ny: {
        factualCode: 'NY',
        name: 'New York',
        regionCode: 'ny'
      },
      oh: {
        factualCode: 'OH',
        name: 'Ohioa',
        regionCode: 'oh'
      },
      ok: {
        factualCode: 'OK',
        name: 'Oklahoma',
        regionCode: 'ok'
      },
      or: {
        factualCode: 'OR',
        name: 'Oregon',
        regionCode: 'or'
      },
      pa: {
        factualCode: 'PA',
        name: 'Pennsylvania',
        regionCode: 'pa'
      },
      ri: {
        factualCode: 'RI',
        name: 'Rhode Island',
        regionCode: 'RI'
      },
      sc: {
        factualCode: 'SC',
        name: 'South Carolina',
        regionCode: 'sc'
      },
      sd: {
        factualCode: 'SD',
        name: 'South Dakota',
        regionCode: 'sd'
      },
      tn: {
        factualCode: 'TN',
        name: 'Tannessee',
        regionCode: 'tn'
      },
      tx: {
        factualCode: 'TX',
        name: 'Texas',
        regionCode: 'tx'
      },
      ut: {
        factualCode: 'UT',
        name: 'Utah',
        regionCode: 'ut'
      },
      va: {
        factualCode: 'VA',
        name: 'Virginia',
        regionCode: 'va'
      },
      vt: {
        factualCode: 'VT',
        name: 'Vermont',
        regionCode: 'vt'
      },
      wa: {
        factualCode: 'WA',
        name: 'Washington',
        regionCode: 'wa'
      },
      wc: {
        factualCode: 'WC',
        name: 'West Virginia',
        regionCode: 'wc'
      },
      wi: {
        factualCode: 'WI',
        name: 'Wisconsin',
        regionCode: 'wi'
      },
      wy: {
        factualCode: 'WY',
        name: 'Wyoming',
        regionCode: 'wy'
      }
    }
  },
  uy: {
    countryCode: 'uy',
    name: 'Uruguay'
  },
  uz: {
    countryCode: 'uz',
    name: 'Uzbekistan'
  },
  va: {
    countryCode: 'va',
    name: 'Vatican City'
  },
  vb: {
    countryCode: 'vb',
    name: 'British Virgin Islands'
  },
  vc: {
    countryCode: 'vc',
    name: 'Saint Vincent and the Grenadines'
  },
  vd: {
    countryCode: 'vd',
    name: 'North Vietnam'
  },
  ve: {
    countryCode: 've',
    name: 'Venezuela'
  },
  vi: {
    countryCode: 'vi',
    name: 'U.S. Virgin Islands'
  },
  vn: {
    countryCode: 'vn',
    name: 'Vietnam'
  },
  vu: {
    countryCode: 'vu',
    name: 'Vanuatu'
  },
  wf: {
    countryCode: 'wf',
    name: 'Wallis and Futuna'
  },
  wk: {
    countryCode: 'wk',
    name: 'Wake Island'
  },
  ws: {
    countryCode: 'ws',
    name: 'Samoa'
  },
  yd: {
    countryCode: 'yd',
    name: 'People\s Democratic Republic of Yemen'
  },
  ye: {
    countryCode: 'ye',
    name: 'Yemen'
  },
  yt: {
    countryCode: 'yt',
    name: 'Mayotte'
  },
  za: {
    countryCode: 'za',
    name: 'South Africa'
  },
  zm: {
    countryCode: 'zm',
    name: 'Zambia'
  },
  zw: {
    countryCode: 'zw',
    name: 'Zimbabwe'
  },
  zz: {
    countryCode: 'zz',
    name: 'Unknown or Invalid Region'
  }
};
